import { getIndicesOf } from "./getIndicesOf.js";
function composeTokens(text, pattern, caseSensitive) {
  const indices = getIndicesOf(pattern, text, caseSensitive);
  const patternLength = pattern.length;
  if (indices.length === 0) {
    return [
      {
        text,
        match: false
      }
    ];
  }
  let sourceIndex = 0;
  const tokens = [];
  for (const index of indices) {
    if (index > sourceIndex) {
      tokens.push({
        text: text.substring(sourceIndex, index),
        match: false
      });
    }
    tokens.push({
      text: text.substring(index, index + patternLength),
      match: true
    });
    sourceIndex = index + patternLength;
  }
  if (sourceIndex < text.length) {
    tokens.push({
      text: text.substring(sourceIndex, text.length),
      match: false
    });
  }
  return tokens;
}
export {
  composeTokens
};
//# sourceMappingURL=composeTokens.js.map
